import Vue from "vue";
import {
  Icon,
  Tab,
  Tabs,
  List,
  Cell,
  Button,
  Popup,
  Field,
  Dialog,
  Toast,
  Swipe,
  SwipeItem,
  Area,
  NavBar,
  CellGroup,
  Image,
  Sticky
} from "vant";

Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(List);
Vue.use(Cell);
Vue.use(Button);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Area);
Vue.use(NavBar);
Vue.use(CellGroup);
Vue.use(Image);
Vue.use(Sticky);
